var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var s = Object.defineProperty;
var L = Object.getOwnPropertyDescriptor;
var W = Object.getOwnPropertyNames;
var g = Object.prototype.hasOwnProperty;
var k = function(e, n) {
    for(var i in n)s(e, i, {
        get: n[i],
        enumerable: !0
    });
}, H = function(e, n, i, r) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (n && typeof n == "object" || typeof n == "function") try {
        var _loop = function(_iterator, _step) {
            var t = _step.value;
            !g.call(e, t) && t !== i && s(e, t, {
                get: function() {
                    return n[t];
                },
                enumerable: !(r = L(n, t)) || r.enumerable
            });
        };
        for(var _iterator = W(n)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop(_iterator, _step);
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
};
var y = function(e) {
    return H(s({}, "__esModule", {
        value: !0
    }), e);
};
var R = {};
k(R, {
    default: function() {
        return Y;
    }
});
module.exports = y(R);
var D = !1, o, p, m, u, d, M, l, w, x, E, F, _, h, A, X;
function a() {
    if (!D) {
        D = !0;
        var e = navigator.userAgent, n = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(e), i = /(Mac OS X)|(Windows)|(Linux)/.exec(e);
        if (_ = /\b(iPhone|iP[ao]d)/.exec(e), h = /\b(iP[ao]d)/.exec(e), E = /Android/i.exec(e), A = /FBAN\/\w+;/i.exec(e), X = /Mobile/i.exec(e), F = !!/Win64/.exec(e), n) {
            o = n[1] ? parseFloat(n[1]) : n[5] ? parseFloat(n[5]) : NaN, o && document && document.documentMode && (o = document.documentMode);
            var r = /(?:Trident\/(\d+.\d+))/.exec(e);
            M = r ? parseFloat(r[1]) + 4 : o, p = n[2] ? parseFloat(n[2]) : NaN, m = n[3] ? parseFloat(n[3]) : NaN, u = n[4] ? parseFloat(n[4]) : NaN, u ? (n = /(?:Chrome\/(\d+\.\d+))/.exec(e), d = n && n[1] ? parseFloat(n[1]) : NaN) : d = NaN;
        } else o = p = m = d = u = NaN;
        if (i) {
            if (i[1]) {
                var t = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(e);
                l = t ? parseFloat(t[1].replace("_", ".")) : !0;
            } else l = !1;
            w = !!i[2], x = !!i[3];
        } else l = w = x = !1;
    }
}
var v = {
    ie: function ie() {
        return a() || o;
    },
    ieCompatibilityMode: function ieCompatibilityMode() {
        return a() || M > o;
    },
    ie64: function ie64() {
        return v.ie() && F;
    },
    firefox: function firefox() {
        return a() || p;
    },
    opera: function opera() {
        return a() || m;
    },
    webkit: function webkit() {
        return a() || u;
    },
    safari: function safari() {
        return v.webkit();
    },
    chrome: function chrome() {
        return a() || d;
    },
    windows: function windows() {
        return a() || w;
    },
    osx: function osx() {
        return a() || l;
    },
    linux: function linux() {
        return a() || x;
    },
    iphone: function iphone() {
        return a() || _;
    },
    mobile: function mobile() {
        return a() || _ || h || E || X;
    },
    nativeApp: function nativeApp() {
        return a() || A;
    },
    android: function android() {
        return a() || E;
    },
    ipad: function ipad() {
        return a() || h;
    }
}, b = v;
var f = !!((typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && window.document && window.document.createElement), C = {
    canUseDOM: f,
    canUseWorkers: (typeof Worker === "undefined" ? "undefined" : _typeof(Worker)) < "u",
    canUseEventListeners: f && !!(window.addEventListener || window.attachEvent),
    canUseViewport: f && !!window.screen,
    isInWorker: !f
}, N = C;
var O;
N.canUseDOM && (O = document.implementation && document.implementation.hasFeature && document.implementation.hasFeature("", "") !== !0);
function G(e, n) {
    if (!N.canUseDOM || n && !("addEventListener" in document)) return !1;
    var i = "on" + e, r = i in document;
    if (!r) {
        var t = document.createElement("div");
        t.setAttribute(i, "return;"), r = typeof t[i] == "function";
    }
    return !r && O && e === "wheel" && (r = document.implementation.hasFeature("Events.wheel", "3.0")), r;
}
var I = G;
var P = 10, T = 40, U = 800;
function S(e) {
    var n = 0, i = 0, r = 0, t = 0;
    return "detail" in e && (i = e.detail), "wheelDelta" in e && (i = -e.wheelDelta / 120), "wheelDeltaY" in e && (i = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (n = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (n = i, i = 0), r = n * P, t = i * P, "deltaY" in e && (t = e.deltaY), "deltaX" in e && (r = e.deltaX), (r || t) && e.deltaMode && (e.deltaMode == 1 ? (r *= T, t *= T) : (r *= U, t *= U)), r && !n && (n = r < 1 ? -1 : 1), t && !i && (i = t < 1 ? -1 : 1), {
        spinX: n,
        spinY: i,
        pixelX: r,
        pixelY: t
    };
}
S.getEventType = function() {
    return b.firefox() ? "DOMMouseScroll" : I("wheel") ? "wheel" : "mousewheel";
};
var Y = S;
0 && (module.exports = {}); /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ 
//# sourceMappingURL=index.js.map